import React from 'react';
import cn from 'classname';

import viewInNewWindow from '../../../../shared/view-in-new-window';

import EventCount from '../../../components/event-count';

import { enum as mailingTypes } from '../../../../../../../../enums/mailing-types';
import { enum as mailingEvents } from '../../../../../../../../enums/mailing-events';

const type = mailingTypes.manual;

function MailingSubRow({ className, template }) {
	const reach = template.reach;
	const mailings = [template.id];

	return (
		<tr className={cn('new-table__body__item', className)}>
			<td colSpan={3} />
			<td>
				{template.title}
			</td>
			<td>
				{template.id}
			</td>
			<td>
				{reach}
			</td>
			<td>
				<EventCount
					mailings={mailings}
					type={type}
					event={mailingEvents.open}
					isAtLeastOneUniqueEvent={!!template.unique_opens}
					reach={reach}
					count={template.opens}
				/>
			</td>
			<td>
				<EventCount
					mailings={mailings}
					type={type}
					event={mailingEvents.click}
					isAtLeastOneUniqueEvent={!!template.unique_clicks}
					reach={reach}
					count={template.clicks}
				/>
			</td>
			<td>
				<EventCount
					mailings={mailings}
					type={type}
					event={mailingEvents.bounce}
					isAtLeastOneUniqueEvent={!!template.unique_bounces}
					reach={reach}
					count={template.bounces}
				/>
			</td>
			<td>
				<EventCount
					mailings={mailings}
					type={type}
					event={mailingEvents.unsub}
					isAtLeastOneUniqueEvent={!!template.unique_unsubs}
					reach={reach}
					count={template.unsubs}
				/>
			</td>
			<td>
				<div className='action-list'>
					<a
						className='view-icon'
						onClick={() => viewInNewWindow(template.text)}
					/>
				</div>
			</td>
		</tr>
	);
}

export default MailingSubRow;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/mailings-new/manual-mailings/list/components/mailing-sub-row.js